import { AvailabilityChangelog } from "PFApp/components/changelog/components/availability_changelog/availability_changelog";
import { ChangelogItem } from "PFApp/components/changelog/components/changelog_item";
import { CustomFieldsChangelog } from "PFApp/components/changelog/components/custom_fields_changelog/custom_fields_changelog";
import { ElementPill } from "PFApp/components/changelog/components/element_pill";
import { Stack } from "PFComponents/containers";
import { AvailabilityChange, CustomFieldsChanges } from "PFCore/types";
import { NotificationChanges } from "PFTypes/notifications";
import { useTranslation } from "react-i18next";

import { formatSimpleChange, isSimpleChange } from "./notification_changelog.utils";

type NotificationChangelogProps = {
  changes: NotificationChanges | undefined;
};

export const NotificationChangelog = ({ changes }: NotificationChangelogProps) => {
  const { t } = useTranslation("core");
  if (!changes || Object.keys(changes).length === 0) {
    return null;
  }

  return (
    <Stack>
      {Object.entries(changes).map(([key, value]) => {
        if (key === "availability") {
          return <AvailabilityChangelog key={key} change={value as AvailabilityChange} />;
        }

        if (key === "customFields") {
          return <CustomFieldsChangelog key={key} customFields={value as CustomFieldsChanges} />;
        }

        if (isSimpleChange(value)) {
          const { before, after } = formatSimpleChange(key, value, t);
          return (
            <ChangelogItem
              key={key}
              before={<ElementPill title={before}>{before}</ElementPill>}
              after={
                <ElementPill highlighted title={after}>
                  {after}
                </ElementPill>
              }
            />
          );
        }
      })}
    </Stack>
  );
};
